export default "__VITE_ASSET__CrijFAMj__"